'use client';

import { FC } from 'react';
import {
  TBreakPointKeysType,
  useBreakPointDown,
  useBreakPointUp,
} from '@/hooks/breakPoint';

export interface IHiddenProps {
  down?: TBreakPointKeysType;
  up?: TBreakPointKeysType;
  children: any;
}

const Hidden: FC<IHiddenProps> = ({ children, up, down }) => {
  const useIsoBreakPointDown = down ? useBreakPointDown : () => true;
  const useIsoBreakPointUP = up ? useBreakPointUp : () => true;

  const isDown: boolean = useIsoBreakPointDown(down as TBreakPointKeysType);
  const isUp: boolean = useIsoBreakPointUP(up as TBreakPointKeysType);

  return isDown && isUp ? null : children;
};

export default Hidden;
